import { Header } from '@/components/Generic'
import { observer } from 'mobx-react'
import { Illustration } from '@/components/Illustration/Illustration'

interface SuccessFinishForNowPageProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trans: any
  fullName: string
}

export const SuccessFinishForNowPage = observer(
  ({ trans, fullName }: SuccessFinishForNowPageProps) => {
    return (
      <div className="page-container mobile-m-0">
        <>
          <Illustration type="sign-document-success" />
          <Header className="no-margin">{trans.header}</Header>
          <p className="generic__paragraph-centered">{trans.line1}</p>
          <div className="generic__spacer h-4" />
          <p className="generic__paragraph-centered">{trans.line2}</p>

          <div className="enpal__name-wrapper">{fullName}</div>

          <p className="generic__paragraph-centered">{trans.line3}</p>
        </>
      </div>
    )
  }
)
